import { useEffect, useState, type ReactNode } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { teamService } from '../../services/teamService';

interface Props {
  children: ReactNode;
}

/**
 * Root-level pages like HomePage don't call any API themselves, so an expired/missing
 * session would otherwise only surface once the user clicks into Companies or
 * My pre-orders and that page's own fetch gets a 401. This forces the auth check
 * (and the apiClient interceptor's redirect to /login) to happen right on landing.
 */
export default function RequireAuth({ children }: Props) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    teamService.getCurrentUser().catch(() => {}).finally(() => {
      if (!cancelled) {
        setChecked(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!checked) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
}
